export default function TinyMCEContent({ content, className }: { className?: string; content: string }) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      className={`${className && className} editor`}
    />
  );
}
